import AvaliacaoSecao from './AvaliacaoSecao';
import Avaliador from './Avaliador';
import Cliente from './Cliente';
import Empresa from './Empresa';
import Questionario from './Questionario';

const STATUS_INICIADA = 'iniciada';
const STATUS_CANCELADA = 'cancelada';
const STATUS_FINALIZADA = 'finalizada';

/**
 * Status possíveis da avaliação
 */
const AvaliacaoStatus = [ STATUS_INICIADA, STATUS_CANCELADA, STATUS_FINALIZADA ];

/**
 * Objeto que representa os dados de uma avaliação
 */
class Avaliacao {

    /**
     * 
     * @param {int} id Id da avaliação na API
     * @param {Empresa} empresa Dados da empresa vinculada à avaliação
     * @param {Questionario} questionario Questionário base para a avaliação
     * @param {Cliente} cliente Dados do cliente vinculado à avaliação
     * @param {Avaliador} avaliador Dados do avaliador vinculado à avaliação
     * @param {string} status Status da avaliação
     * @param {Array<AvaliacaoSecao>} secoes Lista de seções da avaliação
     * @param {Date} dataCadastro Data em que a avaliação foi iniciada
     * @param {Date} dataAlteracao Data da última alteração da avaliação
     */
    constructor (id, status, empresa, questionario, cliente, avaliador, secoes, dataCadastro, dataAlteracao) {
        /** @member {int} id Id da avaliação na API */
        this.id           = id     ?? null;
        /** @member {string} status Status da avaliação */
        this.status       = status ?? STATUS_INICIADA;
        /** @member {Array<AvaliacaoSecao>} secoes Lista de seções da avaliação */
        this.secoes       = secoes ?? [];
        /** @member {Empresa} empresa Dados da empresa vinculada à avaliação */
        this.empresa      = empresa ?? new Empresa();
        /** @member {Cliente} cliente Dados do cliente vinculado à avaliação */
        this.cliente      = cliente ?? new Cliente();
        /** @member {Avaliador} avaliador Dados do avaliador vinculado à avaliação */
        this.avaliador    = avaliador ?? new Avaliador();
        /** @member {Questionario} questionario Questionário base para a avaliação */
        this.questionario = questionario ?? new Questionario();
        /** @param {Date} dataCadastro Data em que a avaliação foi iniciada */
        this.dataCadastro = dataCadastro ?? null;
        /** @param {Date} dataAlteracao Data da última alteração da avaliação */
        this.dataAlteracao = dataAlteracao ?? null;
    }

    /**
     * Cria uma cópia do objeto
     * @param {Avaliacao} origem Objeto a ser copiado
     * @returns {Avaliacao} Novo objeto com os mesmos dados que o original
     */
    static clone(origem) {
        //Copia a lista de seções
        let secoes = null;
        if (origem.secoes)
            secoes = origem.secoes.map(secao => AvaliacaoSecao.clone(secao));
        
        //Copia as propriedades
        let cliente = null;
        if (origem.cliente)
            cliente = Cliente.clone(origem.cliente);
        
        let questionario = null;
        if (origem.questionario)
            questionario = Questionario.clone(origem.questionario);
        
        let empresa = null;
        if (origem.empresa)
            empresa = Empresa.clone(origem.empresa);
        
        let avaliador = null;
        if (origem.avaliador)
            avaliador = Avaliador.clone(origem.avaliador);
        
        let dataCadastro = null;
        if (origem.dataCadastro)
            dataCadastro = new Date(origem.dataCadastro);
        
        let dataAlteracao = null;
        if (origem.dataAlteracao)
            dataAlteracao = new Date(origem.dataAlteracao);

        return new Avaliacao(origem.id, origem.status, empresa, questionario, cliente, avaliador, secoes, dataCadastro, dataAlteracao);
    }
}

export default Avaliacao;
export { AvaliacaoStatus, STATUS_INICIADA, STATUS_CANCELADA, STATUS_FINALIZADA };